import { ChangeDetectionStrategy, Component } from "@angular/core";
import { DualCommunicatorService } from "../../services/internal-services/dual-communicator.service";
import { DualViewComponent } from "./dual-view.component";
import { ToastService } from "../../services/internal-services/toast.service";
import { GeoService } from "../../services/internal-services/geo.service";
import { ViewerConstants } from "../../../shared/model/viewer-constants";
import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../../shared/model/google-analytics-constants";
import { ToolbarService } from "../../services/internal-services/toolbar.service";
import { UrlStateService } from "../../services/internal-services/url-state.service";
import { MapService } from "../../services/internal-services/map.service";

import { FeatureFlagsService } from "../../services/internal-services/feature-flags.service";
import { GoogleAnalyticsService } from "../../../shared/services/google-analytics.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-phoenix-dual-view",
  templateUrl: "./dual-view.component.html",
  styleUrls: ["./dual-view.component.scss"],
  standalone: false,
})
export class PhoenixDualViewComponent extends DualViewComponent {
  constructor(
    dualService: DualCommunicatorService,
    visionToastService: ToastService,
    toolbarService: ToolbarService,
    private urlStateService: UrlStateService,
    private mapService: MapService,
    private googleAnalyticsService: GoogleAnalyticsService,
    flagService: FeatureFlagsService,
  ) {
    super(dualService, visionToastService, toolbarService, flagService);
  }

  ngOnInit() {
    super.ngOnInit();
    // subscription to enable dual view after initialization by state parameter
    this.subscriptions.push(
      this.viewerService.enableDualView$.subscribe((enabled: boolean) => {
        // force to oposite status to call change status
        this.enabled = !enabled;
        this.changeDualViewStatus();
      }),
    );
  }

  changeDualViewStatus() {
    this.enabled = !this.enabled;
    if (this.enabled) {
      const extent = GeoService.bboxFromPoints(this.viewerService.getCoreMap().getExtent());

      const center = GeoService.pointFromArray(this.viewerService.getCoreMap().getCenter());
      const zoom = this.viewerService.getCoreMap().getZoom();
      const startMapStatus = this.mapService.calculateMapStatus(center, extent, zoom);
      this.dualCommunicatorService.updateStartConfiguration(
        startMapStatus,
        this.viewerService.getProjectStatus(),
        this.viewerService.getCollections(),
        this.viewerService.getSelectedBaseLayer(),
        this.viewerService.getOverlayLayers(),
        this.viewerService.is3DMode(),
        this.viewerService.orientationSelected,
        this.toolbarService.getEnableTool(),
        this.viewerService.getInfoProperties(),
      );

      //Check if url has state2 if not set a copy of main state param
      if (!this.urlStateService.getStateParamWithKey("state2")) {
        const state = this.dualCommunicatorService.mapStatus.get(this.mapService.getMapId());
        const stateParams = this.urlStateService.setStateURLWithParams("state2", state);
        this.urlStateService.updateQueryParams(stateParams);
      }
    } else {
      // remove state2 parameter from the url
      this.urlStateService.updateQueryParams({ state2: null });
    }

    this.dualCommunicatorService.updateEnableSync(this.enabled);
    this.dualCommunicatorService.updateDualStatus(this.enabled);

    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.DUAL_VIEW,
      GoogleAnalyticsConstantsCategory.LEFT_TOOLBAR,
      true,
    );
  }
}
